const desc = `<p>
  על<span class="bold"> ביהודה החדשה - האחדות</span> כו חשון תרע"ב [1911 11 17]
</p>`;

export default desc;
